import React from "react";
import classNames from "classnames";

import "./ConsentModal.scss";
import { getString } from "./strings";
import { Language } from "../core";

interface ConsentModalProps {
  language: Language;
  isOpen: boolean;
  onConsent: () => void;
  onDoNotConsent: () => void;
}
export const ConsentModal: React.FC<ConsentModalProps> = React.memo(
  ({ language, isOpen, onConsent, onDoNotConsent }) => {
    return (
      <div className={classNames("consentModal", { isOpen })}>
        <div className="consentModal--inner">
          <p
            dangerouslySetInnerHTML={{
              __html: getString(language, "consentDescription")
            }}
          />
          <button onClick={onConsent} disabled={!isOpen}>
            {getString(language, "consentButton")}
          </button>
          <button onClick={onDoNotConsent} disabled={!isOpen}>
            {getString(language, "doNotConsentButton")}
          </button>
        </div>
      </div>
    );
  }
);
